module.exports = __webpack_public_path__ + "img/otp.a91db059.svg";